<template>		
	<v-sheet color="transparent">
		<h2 class="cn-font light grey--text mb-6">{{title}}</h2>	
		<v-card color="white" tile class="pa-4 mb-5">
			<v-list>
				<v-component v-for="item in items" :is="list_item" :key="item.list_item" :item="item"></v-component>
			</v-list>
		</v-card>
		
	</v-sheet>
</template>		
<script>
	import Vuex from "vuex"
	export default {
		name: "List",
		props: ["title", "collection", "list_item"], 
		data: () => {
			return {

			}
		},
		components: {
			UserListItem: () => import("@/components/info/UserListItem"),
			SurveyListItem: () => import("@/components/survey/SurveyListItem"),
		},
		computed: {
			...Vuex.mapState({
				items(state){
					return state[this.collection]
				}
			})
		},
		methods: {
		},
		mounted(){

			this.$store.dispatch(`${this.collection}/getAll`  )
		} 
	}
</script>